import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "use-socket.io-client";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import {
  useAppEvenListSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  APPLICATION_GLOBAL_SLUG,
  CRYPTO_SECRET_KEY,
  INSIDERODEO_EVENT_STORAGE,
  paginate,
  PER_PAGE,
  RODEO_PAGE_NAME,
  SELECTED_EVENT_STORAGE,
  SOCKET_CHANNEL,
  SOCKET_URL,
  STORAGE,
  URLS,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import clsx from "clsx";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import Sponsor from "src/components/common/Sponsor";
import Sidebar from "src/components/common/Sidebar";
import UpcomingRodeoEventComponent from "./upcomingRodeoEvent";
// import Pagination from 'react-js-pagination';

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);
const queryString = require("query-string");

export default function RodeoEventPage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const location = useLocation();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  // const eventListSelector = useAppEvenListSelector();
  const [eventListSelector, setEventListSelector] = useState<any>();
  const loginReq = useAppRodeoEventLoginRequiredSelector();
  const [eventListData, setEventListData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [isFetching, setIsFetching] = useState(false);
  const [isPageChange, setIsPageChange] = useState<boolean>(false);
  const userApi = useUserApi();
  const userAction = useAppUserAction();
  const [gameId, setGameId] = useState<any>();

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);

  const gotoPerformancesPage = (e: any, re: any) => {
    e?.preventDefault();
    const eventId = cryptr.encrypt(re.id);
    localStorage.setItem(SELECTED_EVENT_STORAGE, eventId);
    eventAction.setSiteHeader(re.rodeo_event_game_info.enable_header);
    eventAction.setStatusMsg(re.status_msg);
    history.push(`/performances/${eventId}`);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    fetchMoreListItems();
  }, [isFetching]);

  // Below function excute the scroll operation text show or hide
  function handleScroll() {
    if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight || isFetching)
      return;
    if (eventListData.length === total) return; //Disable scrolling state if total event data is equal to total data
    setIsFetching(true);
  }

  //Get event List
  const getEventList = () => {
    var params = {
      page: page,
      perPage: PER_PAGE,
    };

    eventApi.callGetEventList(
      params,
      (message: string, resp: any) => {
        if (resp?.list?.length == 1) {
          gotoPerformancesPage(null, resp.list[0]);
        }
        if (resp && resp.list && resp.list && resp.list.length) {
          setEventListSelector(resp);
          setEventListData((prevState) => [...prevState, ...paginate(resp.list, PER_PAGE, page)]);
          setTotal(resp.list.total ? parseInt(resp.list.total) : 0);
          setPage(page + 1);
          setIsFetching(false);
          setGameId(resp?.game_details?.id);
        } else {
          setEventListData((prevState) => [...prevState]);
          setIsFetching(false);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  //On page scroll load more data
  // Event api call once again
  const fetchMoreListItems = () => {
    setTimeout(() => {
      getEventList();
    }, 2000);
  };

  const getStatusMessage = () => {
    let params = {
      game_id: gameId,
    };
    eventApi.callGetGameStatusText(
      params,
      (message: any, resp: any) => {},
      (message: any) => {}
    );
  };

  useEffect(() => {
    if (gameId) {
      getStatusMessage();
    }
  }, [gameId]);

  //First Time call When component is load
  useEffect(() => {
    getEventList();
  }, []);

  // const handlePageChange = (inputPage: number) => {
  //     console.log("Page change call");
  //     if (page !== inputPage) {
  //         setIsPageChange(true)
  //         setPage(inputPage)
  //     }
  // }

  //Pagination page change api call
  // useEffect(() => {
  //     if (isPageChange) {
  //         getEventList()
  //     }
  // }, [page, perPage])

  useEffect(() => {
    localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);

    const parsedHash = queryString.parse(location.hash);
    // console.log(parsedHash)
    if (parsedHash && parsedHash.userToken && parsedHash.userToken != "null") {
      localStorage.setItem("parshedHash", "1");
      // userApi.callCreateUpdateUserGame(
      //     {
      //         game_slug: APPLICATION_GLOBAL_SLUG
      //     },
      //     (message: string, resp: any) => {
      //         console.log({resp})
      //     }, (message: string) => {

      //     }
      // )
      userAction.resetGuestUserId();
      localStorage.removeItem("guestUserId");
      localStorage.setItem(STORAGE, parsedHash.userToken);
      userApi.callGetMe(
        (message: string, resp: any) => {},
        (message: string, resp: any) => {
          history.push(URLS.HOME);
          userAction.logout();
        }
      );
    }
    if (parsedHash && parsedHash.token) {
      localStorage.setItem(INSIDERODEO_EVENT_STORAGE, parsedHash.token);
      //     if (userDetails) {
      history.push(`/performances/${localStorage.getItem(INSIDERODEO_EVENT_STORAGE)}`);
      //     } else {
      //         history.push(URLS.LOGIN)
      //     }
      // } else if (isInsideRodeoTokenExists) {
    } else if (localStorage.getItem(INSIDERODEO_EVENT_STORAGE)) {
      history.push(`/performances/${localStorage.getItem(INSIDERODEO_EVENT_STORAGE)}`);
    } else {
      history.push(URLS.HOME);
    }
  }, []);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
    upgrade: true,
    rememberUpgrade: true,
  });

  useEffect(() => {
    // if (userDetails) {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      // console.log({changeEventStatus})
      // eventAction.updateEventGlowingStatus(changeEventStatus)
    });
    // }

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.EVENT_GLOW, (changeEventStatus: any) => {
      console.log({ changeEventStatus });
      eventAction.updateEventGlowingStatus(changeEventStatus);
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.EVENT_LIST} />

        {/* <div style={{ textAlign: "center" }}>
          <img src="/images/logo.svg" alt="Logo" style={{ marginTop: "10px", marginBottom: "10px", width: "200px" }} />
        </div> */}

        <div className="main-content-panel">
          {/* <UpcomingRodeoEventComponent /> */}
          <h1>Rodeo Events</h1>
          <div className="events-list-panel">
            {eventListSelector && eventListSelector.list && eventListSelector.list.length ? (
              eventListSelector.list.map((event: any) => (
                <div
                  key={event.id}
                  className={
                    (event?.rodeo_event_game_info?.is_event_glow == 1 ? "glow " : "") +
                    "events-list-block d-flex align-items-center"
                  }
                  onClick={(e) => gotoPerformancesPage(e, event)}
                >
                  <div className="events-icon d-flex justify-content-center">
                    <img
                      src={event.avatar && event.avatar.thumb ? event.avatar.thumb : "images/no-image.png"}
                      alt={event.title}
                    />
                  </div>
                  <div className="events-list-content">
                    <h4>{event.title}</h4>
                    <p>{event.location ? event.location : "..."}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className={"events-list-block d-flex align-items-center"}>
                <div className="team-list-content">
                  <h4>No events available</h4>
                </div>
              </div>
            )}
          </div>

          {isFetching && (
            <div style={{ color: "#fce006" }}>
              <p>Loading more events. Please wait... </p>
            </div>
          )}
        </div>
        <Sponsor />
      </section>
    </React.Fragment>
  );
}
